module.exports = __webpack_public_path__ + "img/a.2167188b.png";